export class UserEmail {
  emailSeq: number = null;
  idSeq: number = null;
  clientSeq: number = null;
  emailAddr: string = null;
}
